import React, { CSSProperties, FC, ReactNode } from 'react';
import { useGoogleMapsStatus } from '@src/provider/GoogleMapsProvider';

type MapsGateProps = {
  children: ReactNode;
  /** Size of the area the map would take, so the layout doesn't jump. */
  height?: CSSProperties['height'];
  className?: string;
};

/**
 * Renders a map only when Google Maps is available. Otherwise shows a short notice with Retry, so a
 * blocked maps.googleapis.com never leaves a blank map, a spinner or a crashed page.
 */
export const MapsGate: FC<MapsGateProps> = ({
  children,
  height,
  className,
}) => {
  const status = useGoogleMapsStatus();
  if (status === 'ready') {
    return <>{children}</>;
  }
  return (
    <div
      className={`maps-unavailable ${className ?? ''}`}
      style={height != null ? { height } : undefined}
      role="alert"
      data-test-id="c-maps-unavailable"
    >
      <p>The map couldn&apos;t load. Check your connection and try again.</p>
      <button
        type="button"
        className="maps-unavailable_retry"
        onClick={() => window.location.reload()}
      >
        Retry
      </button>
    </div>
  );
};
